import { META_TAG_ENUMS } from '../includes/metaTag.enum';
export default class JsonLdEventTriggerModule {
  init() {
    this.eventBus = window.MetaTagEventBus;
  }
  listener(callback) {
    this.eventBus.on(META_TAG_ENUMS.JSON_LD_EVENT, event => callback(event.detail.data));
  }
}